import type { IconProps } from './types';
import './icons.css';

export default function SortingArrows({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 6}
      height={height || 10}
      viewBox="0 0 6 10"
      className={`icon icon-sorting-arrows ${className || ''}`}
    >
      <path d="m3 0 3 4H0l3-4ZM3 10l3-4H0l3 4Z" fill="currentColor" />
    </svg>
  );
}
